// extracted by mini-css-extract-plugin
export var childrenContainer = "_3i-0";
export var virtualScrollArea = "_3i-1";